import React from 'react'

const Experience = () => {
  return (
    <div className='experience' id='Experience'>
      <div className='achievement'>
        <div className='circle'>3+</div>
        <span>years </span>
        <span>Experience</span>
      </div>

      <div className='achievement'>
        <div className='circle'>10+</div>
        <span>completed </span>
        <span>projects</span>
      </div>

      <div className='achievement'>
        <div className='circle'>1</div>
        <span>Freelance </span>
        <span>work</span>
      </div>
    </div>
  )
}

export default Experience
